import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface IPublishConfirmDialogProps {
  open: boolean;
  isPublishing: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function PublishConfirmDialog({ open, isPublishing, onClose, onConfirm }: IPublishConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Publish Events</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will publish all events for the current week and notify all assigned employees via email and in-app notification. Are you sure?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm} disabled={isPublishing}>
          Publish
        </Button>
      </DialogActions>
    </Dialog>
  );
}